import React from 'react'

export const PortableStyleNormal = { title: 'Normal', value: 'normal' }
export const PortableStyleH2 = { title: 'H2', value: 'h2' }
export const PortableStyleH3 = { title: 'H3', value: 'h3' }
export const PortableStyleH4 = { title: 'H4', value: 'h4' }
export const PortableStyleBlockQuote = { title: 'Quote', value: 'blockquote' }

export const Small = {
  title: 'Small',
  value: 'small',
  blockEditor: {
    render: (props: any) => (
      <span style={{ fontSize: '14px' }}>{props.children}</span>
    ),
  },
}

export const Large = {
  title: 'Large',
  value: 'large',
  blockEditor: {
    render: (props: any) => (
      <span style={{ fontSize: '18px' }}>{props.children}</span>
    ),
  },
}

export const XLarge = {
  title: 'X Large',
  value: 'xLarge',
  blockEditor: {
    render: (props: any) => (
      <span style={{ fontSize: '20px' }}>{props.children}</span>
    ),
  },
}

export const PortableStyleIndent = {
  title: 'Indent',
  value: 'indent',
  blockEditor: {
    render: (props: any) => (
      <p style={{ paddingLeft: '1.5em' }}>{props.children}</p>
    )
  }
}

export const PortableStylesFull = [
  PortableStyleNormal,
  Small,
  Large,
  XLarge,
  PortableStyleH2,
  PortableStyleH3,
  PortableStyleH4,
  PortableStyleBlockQuote,
  PortableStyleIndent,
]
